import { render, staticRenderFns } from "./FacebookInstagramAdPreview.vue?vue&type=template&id=4c9cac3a&scoped=true&"
import script from "./FacebookInstagramAdPreview.vue?vue&type=script&lang=js&"
export * from "./FacebookInstagramAdPreview.vue?vue&type=script&lang=js&"
import style0 from "./FacebookInstagramAdPreview.vue?vue&type=style&index=0&id=4c9cac3a&lang=scss&scoped=true&"
import style1 from "./FacebookInstagramAdPreview.vue?vue&type=style&index=1&id=4c9cac3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9cac3a",
  null
  
)

export default component.exports